import { render, staticRenderFns } from "./postDetail.vue?vue&type=template&id=411e7b44"
import script from "./postDetail.vue?vue&type=script&lang=js"
export * from "./postDetail.vue?vue&type=script&lang=js"
import style0 from "./postDetail.vue?vue&type=style&index=0&id=411e7b44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports